// import './gallery.css';

const gallery = () => {
    return (
        <div className='min-h-screen mx-auto max-w-7xl px-4 lg:px-8 py-8 font-[Open Sans]' id='gallery'>
            <h3 className='underline underline-offset-4 uppercase'>Event's Gallery</h3>

            <div className='pt-3 leading-snug'>
                <span>Date: June 19, 2025</span>
                <h3 className='font-bold'>Stakeholder Workshop</h3>
            </div>
        </div>
    )
}

export default gallery;